import lodashGet from 'lodash/get';

import StringTranslate from '../assets/i18n/stringLanguage.jsx';

export const paramsSearchProviderHelper = {

    //Permet de vérifier l'idClient, l'idUser, le token du store
    checkStateValues(currentStoreState, reject, checkClientId = true) {

        if (currentStoreState) {

            let idClient = lodashGet(currentStoreState, "clientUserData.clientDatas.id", -1);
            let idUser = lodashGet(currentStoreState, "clientUserData.userDatas.id", -1);
            let tokenValue = lodashGet(currentStoreState, 'connectionData.accessToken', undefined);
            
            if (((checkClientId === true) && ((idClient <= 0) || (!Number.isInteger(idClient)))) || (idUser <= 0) || (tokenValue === undefined)) {
                reject(StringTranslate.noUserDatasIdsOrOrToken);
                return;
            }

            return {
                idClient: idClient,
                idUser: idUser,
                tokenValue: tokenValue,
            };
        }

        reject(StringTranslate.noUserDatasIdsOrOrToken);
        return;
    },

}